import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { ROUTES } from '../routes';

const mono: React.CSSProperties = { fontFamily: "'JetBrains Mono', monospace" };

const ArrowRight = () => (
  <svg viewBox="0 0 16 16" width="13" height="13" fill="none" style={{ stroke: 'currentColor', strokeWidth: 1.6 }}>
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const CARDS = [
  {
    href: ROUTES.howItWorks,
    eyebrow: 'How it works',
    title: 'Dual-signature authorization for smart accounts',
    body: 'How a second, quantum-safe approval clears every privileged action and where it sits in your stack.',
  },
  {
    href: ROUTES.security,
    eyebrow: 'Security & operations',
    title: 'Keep every control, prove every action',
    body: 'The controls issuers retain, and the key governance, monitoring, and recovery that make QSSN operable.',
  },
  {
    href: ROUTES.caseStudies,
    eyebrow: 'Impact',
    title: 'Progress from pilots to production',
    body: 'Mainnet deployments, payment-rail validation, and commercial integrations moving QSSN onto live customer assets.',
  },
];

const ExploreQSSN: React.FC = () => (
  <section style={{ background: 'var(--bg)', padding: '7rem 1.5rem' }}>
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <Reveal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          borderTop: '1px solid var(--line)',
          paddingTop: '1.25rem',
          marginBottom: '3.5rem',
        }}
      >
        <span style={{ ...mono, fontSize: '.6875rem', letterSpacing: '.18em', textTransform: 'uppercase', whiteSpace: 'nowrap', color: 'var(--ink-3)' }}>03</span>
      </Reveal>

      <Reveal style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: '1.5rem' }}>
        {CARDS.map((card) => (
          <Link
            key={card.eyebrow}
            to={card.href}
            className="qssn-explore-card"
            style={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: 280,
              background: 'var(--surface)',
              border: '1px solid var(--line)',
              borderRadius: 14,
              padding: '1.75rem',
              textDecoration: 'none',
            }}
          >
            <span style={{ ...mono, fontSize: '.625rem', letterSpacing: '.16em', textTransform: 'uppercase', whiteSpace: 'nowrap', color: 'var(--accent)' }}>
              {card.eyebrow}
            </span>
            <h3 style={{ margin: '1.4rem 0 0', fontSize: '1.5rem', fontWeight: 500, lineHeight: 1.2, letterSpacing: '-.01em', color: 'var(--ink)' }}>
              {card.title}
            </h3>
            <p style={{ margin: '.85rem 0 0', fontSize: '.9375rem', lineHeight: 1.55, color: 'var(--ink-2)' }}>{card.body}</p>
            <span style={{ marginTop: 'auto', paddingTop: '1.5rem', display: 'inline-flex', alignItems: 'center', gap: '.5rem', fontSize: '.875rem', fontWeight: 500, color: 'var(--accent)' }}>
              Read more <ArrowRight />
            </span>
          </Link>
        ))}
      </Reveal>
    </div>
  </section>
);

export default ExploreQSSN;
